import { Switch } from "@mui/material";
import type { ChangeEvent } from "react";
import ChartOptionFieldShell from "./ChartOptionFieldShell";

type Props = {
  label: string;
  checked: boolean;
  disabled?: boolean;
  helperText?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

export default function ChartOptionSwitchField({
  label,
  checked,
  disabled,
  helperText,
  onChange,
}: Props) {
  return (
    <ChartOptionFieldShell
      label={label}
      helperText={helperText}
      disabled={disabled}
      centerControl
    >
      <Switch size="small" checked={checked} disabled={disabled} onChange={onChange} />
    </ChartOptionFieldShell>
  );
}
